import * as moment from 'moment';
import * as React from 'react';
import {connect} from "react-redux";
import {Auth, CoverNote, Option} from '../../Config/dataModel';
import authState from '../../ReduxRequests/State/authState';
import util from '../../Util/util';
import RecordsTableViewCell from './RecordsTableViewCell';
import RecordsTableViewHeader from './RecordsTableViewHeader';

interface RecordsTableViewProps {
    page: string,
    list: CoverNote[],
    sortBy?: string,
    clickSort?: (sortBy: string) => void,
    searchResult?: CoverNote[],
    identity?: Option,
    identityNo?: string,
    checksum?: string,
    auth?: () => Auth,
    isInsurer?: () => boolean
}

class RecordsTableView extends React.Component <RecordsTableViewProps, {}> {
    public getRecordsTableView() {
        const cells = [];
        let recordsTableViewCellExtraProps = {};
        if (this.props.searchResult) {
            recordsTableViewCellExtraProps = {
                ...recordsTableViewCellExtraProps,
                ...{
                    searchResult: this.props.searchResult,
                    identity: this.props.identity,
                    identityNo: this.props.identityNo,
                    checksum: this.props.checksum
                }
            };
        }
        for (let i = 0; i < this.props.list.length; i++) {
            const data = this.props.list[i].state.data;
            const refNo = this.props.list[i].ref;
            cells.push(
                <RecordsTableViewCell
                    key={i}
                    refNo={refNo}
                    valid={data.status !== 'VOIDED'}
                    arrowDirection={data.requestedBy === this.props.auth().user.userRole ? 'LEFT' : 'RIGHT'}
                    dayLeft={util.getDuration(moment(), moment(data.props.policyEndDate))}
                    status={util.getFlowStatus(true, data.status, false)}
                    issueNumber={data.props.policyReference}
                    company={util.getCompanyName(data.props.subAgentCode, data.props.insurerCode, this.props.auth().allCounterparties, this.props.isInsurer())}
                    license={data.props.licensePlateNumber}
                    endDate={data.props.policyEndDate}
                    policyType={data.props.policyType}
                    {...recordsTableViewCellExtraProps}/>);
        }
        return cells;
    }

    public render() {
        let extraProps = {};
        if (this.props.clickSort) {
            extraProps = {...extraProps, ...{sortBy: this.props.sortBy, clickSort: (sortBy) => this.props.clickSort(sortBy)}};
        }
        return (
            <div className="recordsTableViewContainer">
                <RecordsTableViewHeader page={this.props.page} {...extraProps}/>
                {this.getRecordsTableView()}
            </div>
        );
    }
}

export default connect(authState, null)(RecordsTableView);



// WEBPACK FOOTER //
// ./src/Components/Records/RecordsTableView.tsx